import * as Help from '@ViewModels/root/help'
import { Profile } from '@Enums/profile'

export const HelpRoot = [
	{
		path: 'help',
		component: Help.Main,
		meta: { permission: [Profile.Main, Profile.Demo] },
		children: [
			{
				path:'',
				name:'help',
				component: Help.HomeHelp,
				meta: { permission: [Profile.Main, Profile.Demo] },
			},
			{
				path:'how-it-works',
				name:'how-it-works',
				component: Help.HowItWorks,
				meta: { permission: [Profile.Main, Profile.Demo] },
			}
		]
	}
]
